module.exports = __webpack_public_path__ + "img/menu-icon-privacy-policy.d8672d83.svg";